const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Analyze Reports Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Analyze', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.analyzeUrl + '/api/v1/:resource/:subresource/:itemid', null, {
      totals: {params: {resource: 'totals', subresource: '', users: 'all'}, method: 'GET', isArray: false},
      top5: {params: {resource: 'top-five', subresource: '', users: 'all'}, method: 'GET', isArray: true},
      recent5: {params: {resource: 'recent-five', subresource: '', users: 'all'}, method: 'GET', isArray: true},
      userRecent5: {params: {resource: 'recent-five', subresource: ''}, method: 'GET', isArray: true},
      explore: {params: {resource: 'explore', subresource: ''}, method: 'GET', isArray: false},
      reports: {params: {resource: 'reports', subresource: ''}, method: 'GET', isArray: false},
      modifications: {params: {resource: 'modifications', subresource: ''}, method: 'GET', isArray: true},
      dataFind: {params: {resource: 'data', subresource: ''}, method: 'GET', isArray: true},
      findData: {params: {resource: 'data', subresource: ''}, method: 'POST', isArray: true},
      userViews: {params: {resource: 'views', subresource: 'users'}, method: 'GET', isArray: true},
      viewCount: {params: {resource: 'views', subresource: 'count'}, method: 'GET', isArray: false},
      aggregateViews: {params: {resource: 'views', subresource: 'aggregate'}, method: 'POST', isArray: true},
      record: {params: {resource: '', subresource: ''}, method: 'POST', isArray: false},
      timeline: {params: {resource: 'timeline', subresource: ''}, method: 'GET', isArray: false},
      userVideos: {params: {resource: 'user-videos', subresource: ''}, method: 'GET', isArray: false},
      userPdfs: {params: {resource: 'user-pdfs', subresource: ''}, method: 'GET', isArray: false}
    });
  }]);
